import { createFileRoute, notFound } from "@tanstack/react-router";
import liveStyles from "../styles/live.css?url";
import { LiveRoom } from "../components/live/live-room";
import { creatorPageHead, shellFrom, withStylesheet } from "../lib/head";
import { loadLive } from "../server/live";

/**
 * One live (/streams/:id): the waiting room, then the stream with its chat, then the replay. The
 * page carries only what members may see before they're let in; the video, chat and socket load
 * in the browser through /api/live, each checking the viewer may watch.
 */
export const Route = createFileRoute("/streams/$liveId")({
  loader: async ({ params }) => {
    const data = await loadLive({ data: params.liveId });
    if (!data) throw notFound();
    return data;
  },
  head: ({ matches, loaderData, match }) => {
    const shell = shellFrom(matches);
    if (!shell || !loaderData) return {};
    const head = creatorPageHead(shell, {
      pathname: match.pathname,
      title: `${loaderData.live.title} | ${shell.creator.name}`,
      description: loaderData.live.description || `A live stream from ${shell.creator.name}.`,
      noindex: true,
    });
    return withStylesheet(head, liveStyles);
  },
  component: Live,
});

function Live() {
  const data = Route.useLoaderData();
  // A different live is a different room: its socket and player start over.
  return <LiveRoom key={data.live.id} data={data} />;
}
